import * as types from './mutation-types'

export const incrementAmount = ({ commit }, { shop, amount }) => {
    },
    checkAchievements = (store, { checkBalance }) => {
    }
